import { handlePike13RouteEnter, watchPike13Actions, Pike13 } from './Pike13';
import { redirectHome } from './Migrate.sagas';

export default [
  {
    path: '/migrate/:venueId/pike13',
    component: Pike13,
    pathSagas: [watchPike13Actions],
    locationSagas: [handlePike13RouteEnter],
  },
  {
    path: '/migrate/:venueId',
    pathSagas: [redirectHome],
  },
  {
    path: '/migrate',
    pathSagas: [redirectHome],
  },
];
